import * as React from 'react';
import { debounce as _debounce } from 'lodash';
import { ElementOffset, getOffset } from '../../../api/utils/boundingClientRect';
import { forceWindowResize } from './../../../api/utils/force-resize';

import './Scrollable.container.scss';

export interface ScrollableProps {
  children: React.ReactNode;
  resizeable: boolean;
}

export interface ResizeableScrollContainerProps {
  children: React.ReactNode;
  container: React.RefObject<HTMLDivElement>;
}

export interface ResizeableScrollContainerState {
  style?: {height: number};
}

export class ResizeableScrollContainer extends React.Component<ResizeableScrollContainerProps, ResizeableScrollContainerState> {

  constructor(props: ResizeableScrollContainerProps) {
    super(props);
    this.setHeight = this.setHeight.bind(this);
    this.state = {};
  }

  componentDidMount() {
    this.setHeight();
    window.addEventListener('resize', _debounce(this.setHeight));
  }

  componentDidUpdate(prevProps: ResizeableScrollContainerProps, prevState: ResizeableScrollContainerState) {
    forceWindowResize();
    const {style} = this.state;
    if (!style || (style && !style.height)) {
      this.setHeight();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', _debounce(this.setHeight));
  }

  public render() {
    const {style} = this.state;
    return (
      <div className="row section-resizeable scrollbar" style={style}>
        <div className="col-12 h-100">
          {this.props.children}
        </div>
      </div>
    );
  }

  private setHeight(): void {    
    if (!this.estimatedHight) { return; }
    this.setState({
      style: {
        height: this.estimatedHight
      }
    });
  }

  private get container(): HTMLDivElement {
    return this.props.container && this.props.container.current as HTMLDivElement;
  }

  private get estimatedHight(): number | undefined {
    if (!this.offset) { return; }
    return window.innerHeight - this.offset.top;
  }

  private get offset(): ElementOffset | undefined {
    if (!this.container) {
      return;
    }
    return getOffset(this.container);
  }


}

export class Scrollable extends React.Component<ScrollableProps> {
  
  resizeableContainer: React.RefObject<HTMLDivElement>;

  constructor(props: ScrollableProps) {
    super(props);
    this.resizeableContainer = React.createRef();
  }
  
  public render() {
    if (!this.props.resizeable) {
      return (
        <div className={`section-scrollable scrollbar ${!this.props.resizeable ? 'active' : ''}`}>
          <div className="section-scrollable-inner h-100 pr-2">
            <div className="row h-100 ml-0">
              <div className="col-12 h-100 p-0">
                {this.props.children}
            </div>
          </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="section-resizeable-container" ref={this.resizeableContainer}>
          {this.resizeableContainer && (
            <ResizeableScrollContainer container={this.resizeableContainer}>
              {this.props.children}
            </ResizeableScrollContainer>
          )}
        </div>
      );
    }
  }
}
